module.exports = __webpack_public_path__ + "static/media/bruna.9173cfcd.jpg";